import React from "react";
import { MultiSelect } from "primereact/multiselect";
import { Button, DatePicker, Uploader } from "rsuite";
import { FaCaretDown } from "react-icons/fa";
import PhoneInput from "react-phone-input-2";

function EmployementDetails({ formik, isEditMode }) {

  return (
    <>
      <div className="row">
        <div className="col-12 d-flex flex-column align-items-start">
          <div className="col-12 d-flex">
            <h5
              className="fw-semibold h5-WOeTzEASAL"
              style={{ color: "rgb(43, 81, 147)", marginTop: "1rem" }}
            >
              Employee Details
            </h5>
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Employee ID<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Employee ID"
              value={formik.values.employeeid}
              name="employeeid"
              onChange={(e) => {
                const value = e.target.value.replace(/[^a-zA-Z.\s]/g, "");
                formik.setFieldValue("employeeid", value);
              }}
              disabled={isEditMode}
            />
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3 position-relative">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Department<span className="text-danger">*</span>
            </label>
            <div style={{ position: "relative" }}>
              <select
                className="form-control"
                id="Department"
                name="Department"
                value={formik.values.Department}
                onChange={(e) => formik.setFieldValue("Department", e.target.value)}
                style={{
                  appearance: "none",
                  WebkitAppearance: "none",
                  MozAppearance: "none",
                  paddingRight: "2.5rem",
                }}
              >
                <option value="">Select the Options</option>
                <option value="Administration">Administration</option>
                <option value="Nursing">Nursing</option>
                <option value="others">Others</option>
              </select>
              <FaCaretDown
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  color: "#666",
                }}
              />
            </div>
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Join Date<span className="text-danger">*</span>
            </label>
            <DatePicker
              name="joindate"
              value={formik.values.joindate ? new Date(formik.values.joindate) : null}
              onChange={(value) => formik.setFieldValue("joindate", value)}
              format="dd-MMM-yyyy"
              placeholder="dd-mmm-yyyy"
              oneTap
              style={{ width: "100%", height: "33px", borderRadius: "4px" }}
            />
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Position/Role<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Position/Role"
              value={formik.values.Position}
              name="Position"
              onChange={(e) => formik.setFieldValue("Position", e.target.value)}
              disabled={isEditMode}
            />
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3 position-relative">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Reporting To<span className="text-danger">*</span>
            </label>
            <div style={{ position: "relative" }}>
              <select
                className="form-control"
                id="Reporting"
                name="Reporting"
                value={formik.values.Reporting}
                onChange={(e) => formik.setFieldValue("Reporting", e.target.value)}
                style={{
                  appearance: "none",
                  WebkitAppearance: "none",
                  MozAppearance: "none",
                  paddingRight: "2.5rem",
                }}
              >
                <option value="">Select the Options</option>
                <option value="sara">Dr. Sarah Johnson</option>
                <option value="chen">Dr. Michael Chen</option>
                <option value="others">Others</option>
              </select>
              <FaCaretDown
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  color: "#666",
                }}
              />
            </div>
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3 position-relative">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Employeement Type<span className="text-danger">*</span>
            </label>
            <div style={{ position: "relative" }}>
              <select
                className="form-control"
                id="employeetype"
                name="employeetype"
                value={formik.values.employeetype}
                onChange={(e) => formik.setFieldValue("employeetype", e.target.value)}
                style={{
                  appearance: "none",
                  WebkitAppearance: "none",
                  MozAppearance: "none",
                  paddingRight: "2.5rem",
                }}
              >
                <option value="">Select the Options</option>
                <option value="male">Full-Time</option>
                <option value="female">Part-time</option>
                <option value="others">Contract</option>
              </select>
              <FaCaretDown
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  color: "#666",
                }}
              />
            </div>
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3 position-relative">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Work Schedule<span className="text-danger">*</span>
            </label>
            <div style={{ position: "relative" }}>
              <select
                className="form-control"
                id="Schedule"
                name="Schedule"
                value={formik.values.Schedule}
                onChange={(e) => formik.setFieldValue("Schedule", e.target.value)}
                style={{
                  appearance: "none",
                  WebkitAppearance: "none",
                  MozAppearance: "none",
                  paddingRight: "2.5rem",
                }}
              >
                <option value="">Select the Options</option>
                <option value="male">Morning Shift</option>
                <option value="female">Evening Shift</option>
                <option value="others">Night Shift</option>
              </select>
              <FaCaretDown
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  color: "#666",
                }}
              />
            </div>
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
            Work Hours<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Work Hours"
              value={formik.values.Hours}
              name="Hours"
              onChange={(e) => {
                const value = e.target.value.replace(/[^a-zA-Z.\s]/g, "");
                formik.setFieldValue("Hours", value);
              }}
              disabled={isEditMode}
            />
          </div>
        </div>

      </div>
    </>
  );
}

export default EmployementDetails;
